import React from "react";
import { Skeleton } from "antd";
import { QuestionForm } from "./QuestionsForm";

const QuestionList = ({
  loading,
  questions,
  selectedSubsection,
  expandAll,
  answers,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col gap-4 p-4">
        <Skeleton.Button block active />
        <Skeleton.Button block active />
        <Skeleton.Button block active />
        <Skeleton.Button block active />
      </div>
    );
  }

  if (!selectedSubsection) {
    return null;
  }

  return (
    <div className="mx-20 shadow-[0_0_16px_0_#3BA2B91F]">
      {questions.length > 0 ? (
        <QuestionForm
          questions={questions}
          expandAll={expandAll}
          answers={answers}
        />
      ) : (
        <p className="text-gray-500 text-center">No questions available.</p>
      )}
    </div>
  );
};

export default QuestionList;
